import {
  Box,
  Button,
  Card,
  Divider,
  Grid,
  Link,
  Typography,
  CardContent,
  CardMedia,
  List,
  ListItem,
  ListItemIcon,
  ListItemText
} from '@mui/material';
import './DesktopPlatformTab.scss';
import { useTranslation } from 'react-i18next';
import { Stack } from '@mui/system';
import user from '../../assets/images/acConnex/Vector.png';
import key from '../../assets/images/acConnex/Key.png';
import Check from '../../assets/images/acConnex/CheckIcon.png';
import rightArrow from '../../assets/images/acConnex/chevron-right.png';
import FeaturesCarousel from './CarouselAcConnex';

const getFullImageLink = (image: string) => {
  const env = process.env["REACT_APP_ENV_LOADED"];
  let url = `https://content-ndc-portal.aircanada.com`; //default to prod
  if (env === "DEV" || env === "INT" || env === "CRT") {
    url = `https://content-ndc-portal-int.aircanada.com`;
  } else if (env === "BAT" || env === "PREPROD") {
    url = `https://content-ndc-portal-bat.aircanada.com`;
  }
  return url + image;
};

const DesktopPlatformTab = ({ jsonData }) => {
  // const data = jsonData['desktop-platform'];
  const { t } = useTranslation();

  const quicklinkAndCarosalData = t('ac_connex_accessandquicklinkssection', { returnObjects: true }); 

  const parseListItems = (html: string): string[] => {
    const matches = html.match(/<li>([\s\S]*?)<\/li>/g) || [];
    return matches.map(li => li.replace(/^<li>|<\/li>$/g, ''));
  };
  const accessContent = quicklinkAndCarosalData[0]?.access[0]?.content || '';
  const accessItems = parseListItems(accessContent);
  const totalAccessItems = accessItems.length;

  const heading = t('ac_connex_heading');
  const heroSection = t('ac_connex_herosection', { returnObjects: true });

  const removeHtmlTags = (html: string) => html?.replace(/<[^>]*>/g, '') || '';

  const quicklinks = quicklinkAndCarosalData[0].rightSolutionAndQuickLinks[0].quickLinks[0];
  const quickLinks = quicklinks.list;

  const registerButtonText = heroSection[0].url[0].title;
  const loginButtonText = heroSection[0].url[1].title;

  const handleRegisterClick = () => {
    window.open(heroSection[0].url[0].uri, '_blank');
  };

  const handleLoginClick = () => {
    window.open(heroSection[0].url[1].uri, '_blank');
  };

  return (
    <>
      <Grid container justifyContent={'center'}>
        <Grid
          item
          sx={{
            maxWidth: '1200px',
            marginX: '32px',

            '@media (max-width: 900px)': {
              maxWidth: '704px',
              marginX: '32px'
            },
            '@media (max-width: 600px)': {
              marginX: '32px'
            }
          }}
        >
          <section>
            <Box paddingTop={'30px'}>
              {/* Title */}
              <Typography
                variant="h2"
                mb={4}
                sx={{
                  fontWeight: 700,
                  fontSize: '28px',
                  lineHeight: '36px'
                }}
              >
                {removeHtmlTags(heading)}
              </Typography>

              {/* Top section with image + content */}
              <Card
                sx={{
                  mb: 5,
                  borderRadius: '14px',
                  minHeight: '332px',
                  boxShadow: '0px 0px 15px 0px #00000026 !important'
                }}
              >
                <Grid container spacing={0}>
                  {/* Left: Image */}
                  <Grid item xs={12} md={6}>
                    <Box
                      sx={{
                        pt: 1,
                        px: 3,
                        height: '100%',
                        display: 'flex',
                        alignItems: 'center'
                      }}
                    >
                      <CardMedia
                        component="img"
                        image={getFullImageLink(removeHtmlTags(heroSection[0].image.url))}
                        alt={removeHtmlTags(heroSection[0].image.alt) || 'hero card image'}
                        sx={{
                          borderRadius: '24px',
                          width: '100%',
                          height: '90%',
                          mt: 2,
                          mb: 2.6
                          // py:4,
                          // height: { xs: 200, md: 268 },
                          // objectFit: 'contain',
                          // m: 0
                        }}
                      />
                    </Box>
                  </Grid>

                  {/* Right: Description + Buttons */}
                  <Grid item xs={12} md={6}>
                    <CardContent
                      sx={{
                        pt: 3,
                        px: 3,
                        height: '100%',
                        display: 'flex',
                        flexDirection: 'column'
                      }}
                    >
                      <Typography
                        variant="h3"
                        fontWeight={600}
                        mb={1}
                        sx={{
                          fontWeight: 600,
                          fontSize: '20px',
                          lineHeight: '28px'
                        }}
                      >
                        {removeHtmlTags(heroSection[0].title)}
                      </Typography>
                      <Typography
                        variant="body2"
                        mb={3}
                        sx={{
                          color: '#000000',
                          fontWeight: 400,
                          fontSize: '14px',
                          lineHeight: '20px',
                          wordBreak: 'break-word'
                        }}
                        dangerouslySetInnerHTML={{
                          __html: heroSection[0].description
                        }}
                      />
                      <Stack
                        sx={{
                          display: 'flex',
                          flexDirection: 'row',
                          gap: '10px',
                          '@media(max-width: 900px)': {
                            flexDirection: 'column'
                          }
                        }}
                        alignItems={{ xs: 'center', sm: 'inherit' }}
                        justifyContent={{ xs: 'center', sm: 'flex-start' }}
                      >
                        <Button
                          variant="primary"
                          size="md"
                          onClick={handleRegisterClick}
                          startIcon={<img src={user} alt="" />}
                          sx={{
                            width: { xs: '100%', sm: 'auto' }
                          }}
                        >
                          {registerButtonText}
                        </Button>
                        <Button
                          variant="secondary"
                          size="md"
                          onClick={handleLoginClick}
                          startIcon={<img src={key} alt="" />}
                          sx={{
                            width: { xs: '100%', sm: 'auto' },
                            borderRadius: '50px'
                          }}
                        >
                          {loginButtonText}
                        </Button>
                      </Stack>
                    </CardContent>
                  </Grid>
                </Grid>
              </Card>
            </Box>
          </section>

          <section>
            <Box>
              <Grid container spacing={{ xs: 4 }} alignItems="stretch">
                {/* Left: Access Content */}
                <Grid
                  item
                  xs={12}
                  md={7}
                  sx={{
                    display: 'flex'
                  }}
                >
                  <Box
                    sx={{
                      boxShadow: '0px 0px 15px 0px #00000026 !important',
                      borderRadius: '16px',
                      width: '100%',
                      height: '100%',
                      p: { xs: 2, sm: 3, md: 4 }
                    }}
                  >
                    <Typography
                      variant="h3"
                      fontWeight={600}
                      mb={{ xs: 2, md: 3 }}
                      sx={{
                        fontSize: { xs: '20px', sm: '22px', md: '24px' },
                        lineHeight: { xs: '28px', sm: '30px', md: '32px' },
                        color: '#000000'
                      }}
                    >
                      {removeHtmlTags(quicklinkAndCarosalData[0].access[0].heading)}
                    </Typography>
                    <List sx={{ p: 0, m: 0 }}>
                      {accessItems.map((item, index) => (
                        <ListItem
                          key={index}
                          aria-posinset={index + 1}
                          aria-setsize={totalAccessItems}
                          aria-label={`(${index + 1} of ${totalAccessItems})`}
                          sx={{
                            py: { xs: 1, md: 0.75 },
                            px: 0,
                            alignItems: 'center',
                            position: 'relative'
                          }}
                        >
                          <span
                            style={{
                              position: 'absolute',
                              width: '1px',
                              height: '1px',
                              padding: 0,
                              margin: '-1px',
                              overflow: 'hidden',
                              clip: 'rect(0,0,0,0',
                              whiteSpace: 'nowrap',
                              border: 0
                            }}
                          >
                            •
                          </span>
                          <ListItemIcon sx={{ minWidth: '32px', mt: 0.5 }}>
                            <img
                              src={Check}
                              alt=""
                              style={{
                                width: '16px',
                                height: '12px',
                                objectFit: 'contain',
                                alignItems: 'center'
                              }}
                            />
                          </ListItemIcon>
                          <ListItemText
                            sx={{ m: { xs: 0.5, md: 0 } }}
                            primary={
                              <Typography
                                sx={{
                                  fontWeight: 400,
                                  fontSize: {
                                    xs: '14px',
                                    sm: '15px',
                                    md: '16px'
                                  },
                                  lineHeight: {
                                    xs: '20px',
                                    sm: '22px',
                                    md: '24px'
                                  },
                                  color: '#000000',
                                  m: 0
                                }}
                                dangerouslySetInnerHTML={{ __html: item }}
                              />
                            }
                          />
                        </ListItem>
                      ))}
                    </List>
                  </Box>
                </Grid>

                {/* Right: Info + Links */}
                <Grid
                  item
                  xs={12}
                  md={5}
                  sx={{
                    display: 'flex',
                    flexDirection: 'column'
                  }}
                >
                  <Box
                    sx={{
                      backgroundColor: '#F1F7FB',
                      borderRadius: '16px',
                      p: { xs: 2, sm: 3, md: 4 },
                      height: '100%'
                    }}
                  >
                    {/* Agency Info */}
                    <Box sx={{ mb: { xs: 2, md: 3 } }}>
                      <Typography
                        variant="h4"
                        mb={{ xs: 1, md: 1.5 }}
                        sx={{
                          color: '#003D78',
                          fontWeight: 700,
                          fontSize: { xs: '18px', sm: '19px', md: '20px' },
                          lineHeight: { xs: '26px', sm: '27px', md: '28px' }
                        }}
                      >
                        {removeHtmlTags(quicklinkAndCarosalData[0].rightSolutionAndQuickLinks[0].rightSolution[0].heading)}
                      </Typography>
                      <Box
                        sx={{
                          display: 'flex',
                          alignItems: 'flex-start',
                          mt: 2
                        }}
                      >
                        <img
                          src={Check}
                          alt=""
                          style={{
                            width: '16px',
                            height: '12px',
                            marginRight: '12px',
                            marginTop: '2px',
                            flexShrink: 0,
                            alignSelf: 'center'
                          }}
                        />
                        <Typography
                          variant="body1"
                          sx={{
                            fontWeight: 400,
                            fontSize: { xs: '14px', sm: '15px', md: '16px' },
                            lineHeight: { xs: '20px', sm: '22px', md: '24px' },
                            color: '#000000'
                          }}
                        >
                          {removeHtmlTags(quicklinkAndCarosalData[0].rightSolutionAndQuickLinks[0].rightSolution[0].list)}
                        </Typography>
                      </Box>
                    </Box>

                    <Divider
                      sx={{ borderColor: '#C9CACC', mb: { xs: 2, md: 3 } }}
                    />

                    {/* Quick Links */}
                    <Box>
                      <Typography
                        variant="h4"
                        id="quick-link-heading"
                        mb={{ xs: 1.5, md: 2 }}
                        sx={{
                          color: '#003D78',
                          fontWeight: 700,
                          fontSize: { xs: '18px', sm: '19px', md: '20px' },
                          lineHeight: { xs: '26px', sm: '27px', md: '28px' }
                        }}
                      >
                        {removeHtmlTags(quicklinkAndCarosalData[0].rightSolutionAndQuickLinks[0].quickLinks[0].heading)}
                      </Typography>
                      <List
                        sx={{ p: 0, m: 0 }}
                        aria-labelledby="quick-link-heading"
                      >
                        {quickLinks.map((item, idx) => (
                          <ListItem
                            key={idx}
                            sx={{
                              display: 'flex',
                              flexDirection: 'row',
                              alignItems: 'center',
                              py: { xs: 1, md: 1.5 },
                              px: 0,
                              minHeight: 'auto'
                            }}
                          >
                            <Box sx={{ mr: 1.5, flexShrink: 0 }}>
                              <img
                                src={getFullImageLink(item.image.url)}
                                style={{
                                  width: '18px',
                                  height: '20px',
                                  display: 'flex',
                                  alignSelf: 'center'
                                }}
                                alt={item.image.alt}
                              />
                            </Box>
                            <Link
                              href={item.IsPDF === '1' ? new URL(item.url.uri).pathname : item.url.uri}
                              download={item.IsPDF === '1' ? true : undefined}
                              underline="hover"
                              sx={{
                                color: '#1460AA',
                                fontSize: {
                                  xs: '14px',
                                  sm: '15px',
                                  md: '16px'
                                },
                                fontWeight: 700,
                                lineHeight: {
                                  xs: '20px',
                                  sm: '22px',
                                  md: '24px'
                                },
                                ':hover': {
                                  color: '#003D78'
                                },
                                textDecoration: 'none',
                                '&:hover': {
                                  textDecoration: 'underline'
                                }
                              }}
                            >
                              {item.url.title}
                            </Link>
                            <Box sx={{ ml: 1, flexShrink: 0 }}>
                              <img
                                src={rightArrow}
                                style={{
                                  width: '12px',
                                  height: '12px'
                                }}
                                alt=""
                              />
                            </Box>
                          </ListItem>
                        ))}
                      </List>
                    </Box>
                  </Box>
                </Grid>
              </Grid>
            </Box>
          </section>
        </Grid>
      </Grid>

      {/* Carousel sections - outside Grid item for full width background */}
      <section style={{ marginTop: '50px' }}>
        {quicklinkAndCarosalData[0].carousel.map((carouselData, index) => (
          <Box
            key={carouselData.id}
            sx={{
              backgroundColor: index % 2 === 0 ? '#F1F7FB' : 'white',
              py: { xs: 2, sm: 2 },
              display: 'flex',
              justifyContent: 'center',
              px: { xs: 4 }
            }}
          >
            <Box
              sx={{
                width: '100%',
                maxWidth: '1200px',
                '@media (max-width: 900px)': {
                  maxWidth: '704px'
                }
                // px: { xs: 0, sm: 0, md: 0 }
              }}
            >
              <FeaturesCarousel data={[carouselData]} />
            </Box>
          </Box>
        ))}
      </section>
    </>
  );
};

export default DesktopPlatformTab;